import { Box, Tabs as MuiTabs, Tab as MuiTab } from '@mui/material'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const Container = styled(Box)`
  ${({ theme }) => css`
    margin-top: 16px;
    width: fit-content;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
    }
  `}
`

export const Tabs = styled(MuiTabs)`
  ${({ theme }) => css`
    height: 42px;

    .MuiTabs-indicator {
      height: 3px;
      background-color: ${theme.colors.primary};
    }

    @media (max-width: ${theme.screenSizes.laptop}) {
      height: auto;

      .MuiTabs-flexContainer {
        flex-wrap: wrap;
      }

      .MuiTabs-scroller {
        overflow: visible !important;
      }

      .MuiTabs-indicator {
        display: none;
      }
    }
  `}
`

export const Tab = styled(MuiTab)`
  ${({ theme }) => css`
    height: 42px;
    text-transform: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: ${theme.colors.secondary};
    padding: 8px 24px;
    border-bottom: 3px solid ${theme.colors.border.light};
    border-radius: 8px 8px 0 0;

    &:hover {
      color: ${theme.colors.primary};
      background-color: ${theme.colors.background.hover};
    }

    &.Mui-selected {
      font-weight: 600;
      color: ${theme.colors.primary};
      border-bottom: 3px solid ${theme.colors.primary};
    }

    &.Mui-disabled {
      color: ${theme.colors.gray[300]};
      cursor: not-allowed !important;
      pointer-events: auto;

      &:hover {
        color: ${theme.colors.gray[300]};
        background-color: transparent;
      }
    }

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex: 0 0 auto;
      min-width: fit-content;
    }
  `}
`

export const Content = styled(Box)`
  padding: 16px 0;
`
